(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-sticky-purchasing-bar"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('sht-sticky-variant-picker')) {
    class SHTStickyVariantPicker extends HTMLElement {
      connectedCallback() {
        this.sectionId = this.dataset.section;
        this.select = this.querySelector('.js-product-sticky-variant-select');
        this.details = this.querySelector('.js-product-sticky-variant-details');
        this.currentLabel = this.querySelector('.js-product-sticky-variant-current');
        this.optionButtons = Array.from(this.querySelectorAll('.js-product-sticky-variant-option'));
        this.mainPicker = document.querySelector(`#variantPicker-${CSS.escape(this.sectionId)}`);
        this.productForm = document.querySelector(`#productForm-${CSS.escape(this.sectionId)}`);

        if (!this.select || !this.mainPicker || !this.productForm) return;

        this.select.addEventListener('change', this.onStickyVariantChange.bind(this));
        this.optionButtons.forEach((button) => {
          button.addEventListener('click', this.onCustomOptionClick.bind(this));
        });
        this.mainPicker.addEventListener('change', this.syncFromMainPicker.bind(this));
        this.updateCustomMenu();
      }

      onCustomOptionClick(event) {
        this.select.value = event.currentTarget.dataset.value;
        this.select.dispatchEvent(new Event('change'));
        this.details.removeAttribute('open');
      }

      onStickyVariantChange() {
        const selectedOption = this.select.selectedOptions[0];
        const optionValues = JSON.parse(selectedOption.dataset.options);
        const variantSelector = this.mainPicker.querySelector('sht-variant-radios, sht-variant-selects');

        if (!variantSelector) return;

        let changedControl;

        optionValues.forEach((value, index) => {
          if (variantSelector.matches('sht-variant-selects')) {
            const option = Array.from(variantSelector.querySelectorAll('option.js-variant-item')).find((item) => {
              return item.dataset.variantValue === `${value}-${index}`;
            });

            if (option) {
              option.parentElement.value = value;
              changedControl = option.parentElement;
            }
          } else {
            const radio = Array.from(variantSelector.querySelectorAll('input.js-variant-radio-item')).find((item) => {
              return item.dataset.variantValue === `${value}-${index}`;
            });

            if (radio) {
              radio.checked = true;
              changedControl = radio;
            }
          }
        });

        if (changedControl) {
          changedControl.dispatchEvent(new Event('change', { bubbles: true }));
        }

        this.updateCustomMenu();
      }

      syncFromMainPicker() {
        requestAnimationFrame(() => {
          const variantInput = this.productForm.querySelector('input[name="id"]');

          if (variantInput && this.select.querySelector(`option[value="${variantInput.value}"]`)) {
            this.select.value = variantInput.value;
            this.updateCustomMenu();
          }
        });
      }

      updateCustomMenu() {
        const selectedOption = this.select.selectedOptions[0];

        if (!selectedOption) return;

        this.currentLabel.textContent = selectedOption.textContent.trim();
        this.optionButtons.forEach((button) => {
          const isSelected = button.dataset.value === this.select.value;
          button.classList.toggle('is-active', isSelected);
          button.setAttribute('aria-selected', isSelected.toString());
        });
      }
    }

    customElements.define('sht-sticky-variant-picker', SHTStickyVariantPicker);
  }
  } catch(e) { console.error(e); }
})();

})();
